/**
 * Studio / backlot style locations for production sourcing (shooting).
 * Expand with booking links or detail routes when available.
 */

export const shootingLocations = [
  {
    id: 'ramoji-film-city',
    name: 'Ramoji Film City',
    city: 'Hyderabad',
    region: 'Telangana',
    icon: '🎬',
    imageUrl: '/location-images/ramoji-film-city.jpg',
    summary: 'Large integrated film city with permanent sets, sound stages, and backlots for features, ads, and series.',
  },
  {
    id: 'vcc-studio-hyd',
    name: 'VCC Studio Hyd',
    city: 'Hyderabad',
    region: 'Telangana',
    icon: '🏢',
    imageUrl: '/location-images/vcc-studio-hyd.jpg',
    summary: 'Hyderabad studio space for controlled shoots, interviews, and green-screen work.',
  },
  {
    id: 'rio-studio-bengaluru',
    name: 'Rio Studio Bengaluru',
    city: 'Bengaluru',
    region: 'Karnataka',
    icon: '🎥',
    imageUrl: '/location-images/rio-studio-bengaluru.jpg',
    summary: 'Bengaluru-based studio for production blocks, rehearsals, and technical setups.',
  },
  {
    id: 'voice-art-studio-bombay',
    name: 'Voice Art Studio Bombay',
    city: 'Mumbai',
    region: 'Maharashtra',
    icon: '🎙️',
    imageUrl: '/location-images/voice-art-studio-bombay.jpg',
    summary: 'Mumbai facility suited to dialogue, ADR, and intimate performance-driven shoots.',
  },
  {
    id: 'running-water-studio-dubai',
    name: 'Running Water Studio Dubai',
    city: 'Dubai',
    region: 'UAE',
    icon: '🌊',
    imageUrl: '/location-images/running-water-studio-dubai.jpg',
    summary: 'Dubai location for international productions needing a premium stage or serviced environment.',
  },
  {
    id: 'swatik-villa-hyderabad',
    name: 'Swatik Villa',
    city: 'Hyderabad',
    region: 'Telangana',
    icon: '🏡',
    imageUrl: '/location-images/swatik-villa-hyderabad.jpg',
    summary: 'Villa-style shooting location in Hyderabad suitable for ad films, lifestyle scenes, and compact production setups.',
  },
];
